import { render, staticRenderFns } from "./RegulationsPage.vue?vue&type=template&id=6dc9ac98&scoped=true&"
import script from "./RegulationsPage.vue?vue&type=script&lang=js&"
export * from "./RegulationsPage.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsPage.vue?vue&type=style&index=0&id=6dc9ac98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc9ac98",
  null
  
)

export default component.exports